module.exports = __webpack_public_path__ + "img/icon-file-change.d2b8b138.svg";